import { useMemo } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { AccountMini } from '../common/AccountMini/accountMini';
import { useBlockchainProvider } from '../../providers/Blockchain/blockchainProvider';
import { useTranslation } from 'react-i18next';
import { WalletIcon } from 'src/utils/icons/wallet';

enum CONNECT_TYPES {
	EMPTY,
	NOT_LOGGED,
	LOGGED,
}

export const WalletElement = ({ isMobile }: { isMobile: boolean }) => {
	const { isLoggedIn, login } = useBlockchainProvider();
	const { t } = useTranslation();

	const typeOptions = {
		[CONNECT_TYPES.EMPTY]: () => <Flex />,
		[CONNECT_TYPES.LOGGED]: () => <AccountMini />,
		[CONNECT_TYPES.NOT_LOGGED]: () => (
			<Flex
				onClick={login}
				alignItems="center"
				cursor="pointer"
			>
				{!isMobile && (
					<Text
						whiteSpace="nowrap"
						fontSize="16px"
						fontWeight="600"
						mr="6px"
					>
						{t('default.connect')}
					</Text>
				)}
				<WalletIcon />
			</Flex>
		),
	};

	const connectType = useMemo(() => {
		if (!isLoggedIn) {
			return CONNECT_TYPES.NOT_LOGGED;
		}
		return CONNECT_TYPES.LOGGED;
	}, [isLoggedIn]);

	return <>{typeOptions[connectType]()}</>;
};
